import { Link } from 'react-router-dom';
import { topRatedDramas } from '@/mocks/dramas';

export default function TopRated() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            高分榜单
          </h2>
          <p className="text-sm text-foreground-600 mt-2">评分最高的经典与热门剧集</p>
        </div>
        <Link
          to="/category/all"
          className="text-sm text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap flex items-center gap-1"
        >
          查看全部 <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {topRatedDramas.slice(0, 6).map((drama, index) => (
          <Link
            key={drama.id}
            to={`/article/${drama.id}`}
            className="group flex gap-4 p-4 rounded-lg bg-background-100 hover:bg-background-200 border border-background-200 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
          >
            <div className="flex-shrink-0 w-12 flex items-center justify-center">
              <span className={`text-2xl font-heading font-bold ${
                index < 3 ? 'text-primary-500' : 'text-foreground-400'
              }`}>
                {String(index + 1).padStart(2, '0')}
              </span>
            </div>

            <div className="flex-shrink-0 w-16 h-24 rounded-md overflow-hidden">
              <img
                src={drama.thumbUrl}
                alt={drama.title}
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                  {drama.title}
                </h3>
                <span className="flex-shrink-0 px-1.5 py-0.5 bg-accent-500/20 text-accent-500 text-xs font-semibold rounded">
                  {drama.rating}
                </span>
              </div>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-2">{drama.description}</p>
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-xs text-foreground-400">{drama.category}</span>
                <span className="text-xs text-foreground-400">·</span>
                <span className="text-xs text-foreground-400">{drama.year}</span>
                <span className="text-xs text-foreground-400">·</span>
                <span className="text-xs text-foreground-400">{drama.episodes}</span>
              </div>
            </div>

            <div className="flex-shrink-0 flex items-center">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-300 group-hover:bg-primary-500/20 transition-colors">
                <i className="ri-arrow-right-s-line text-foreground-500 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}